import { LineHeightType } from '../paragraph-manager.interface';
import { PERCENT_LINE_HEIGHT_SLIDE_TO_PPT_RATIO, cmToPt } from '@src/slide/infrastructure/module/independent/unit';
import { MIN_CM, MAX_CM, MIN_PT, MAX_PT } from './const';
import { IParagraphStyle } from '@src/slide/domain/ui-model/element-modeles/property/text/interface/editor-styles.interface';
import { IParagraph } from '@src/slide/domain/ui-model/element-modeles/property/text/interface/editor-para.interface';
import i18n from '@i18next/i18n';
import {
    AlignType,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/text-editor/editor-controller/editor-operations/constant';

const fontSize = 4;

function clippedValue(originalValue: number, min: number, max: number) {
    if (originalValue < min) {
        return min;
    }
    if (originalValue > max) {
        return max;
    }
    return originalValue;
}

export const defaultMultiVal = 1;
export const defaultFixedVal = 20;

const beforeParagraph: IParagraph = {
    paragraphProps: {
        lang: 'ea',
    },
    textRuns: [
        {
            styles: {
                color: '#C4C4C4',
                lang: 'ea',
                fontSize,
            },
            text: i18n.t('前一段落'),
        },
    ],
};

const afterParagraph = {
    paragraphProps: {
        lang: 'ea',
    },
    textRuns: [
        {
            styles: {
                color: '#C4C4C4',
                lang: 'ea',
                fontSize,
            },
            text: i18n.t('后一段落'),
        },
    ],
};

// eslint-disable-next-line complexity
function getPreviewParagraph(updateProps) {
    const {
        alignmentType,
        lineHeightType,
        lineHeight,
        marginLeft,
        textIndent,
        spaceBefore,
        spaceAfter,
        textIndentType,
    } = updateProps;
    const paragraphProps: IParagraphStyle = {};

    if (alignmentType) {
        const alignmentMapping = {
            [AlignType.HORIZONTAL_LEFT]: 'left',
            [AlignType.HORIZONTAL_CENTER]: 'center',
            [AlignType.HORIZONTAL_RIGHT]: 'right',
            [AlignType.HORIZONTAL_JUSTIFY]: 'justify',
            [AlignType.HORIZONTAL_DISTRIBUTE]: 'distribute',
        };
        paragraphProps.textAlign = alignmentMapping[alignmentType] as any;
    }

    if (lineHeightType && lineHeight) {
        if (lineHeightType === LineHeightType.Multi) {
            paragraphProps.PPTLineHeight = lineHeight;
            paragraphProps.lineHeight = lineHeight * PERCENT_LINE_HEIGHT_SLIDE_TO_PPT_RATIO;
            paragraphProps.lineHeightIs = 'percent';
        } else if (lineHeightType === LineHeightType.Fixed) {
            paragraphProps.lineHeight = lineHeight / 2;
            paragraphProps.lineHeightIs = 'absolute';
        }
    }

    if (marginLeft) {
        const clippedMarginLeft = clippedValue(marginLeft, MIN_CM, MAX_CM);
        paragraphProps.marginLeft = cmToPt(clippedMarginLeft, 2);
    }

    if (textIndent && textIndentType) {
        const clippedTextIndent = clippedValue(textIndent, MIN_CM, MAX_CM);
        const indentAbs = textIndentType === 'hanging' ? -clippedTextIndent : clippedTextIndent;
        paragraphProps.textIndent = cmToPt(indentAbs, 2);
    }

    if (spaceBefore) {
        const clippedSpaceBefore = clippedValue(spaceBefore, MIN_PT, MAX_PT);
        paragraphProps.paddingTop = clippedSpaceBefore;
        paragraphProps.paddingTopIs = 'absolute';
    }

    if (spaceAfter) {
        const clippedSpaceAfter = clippedValue(spaceAfter, MIN_PT, MAX_PT);
        paragraphProps.paddingBottom = clippedSpaceAfter;
        paragraphProps.paddingBottomIs = 'absolute';
    }

    return {
        paragraphProps: {
            lang: 'ea',
            ...paragraphProps,
        },
        textRuns: [
            {
                styles: {
                    lang: 'ea',
                    fontSize,
                },
                text: i18n.t('示例文本'),
            },
        ],
    };
}

export function getPreviewParagraphList(updateProps = {}): IParagraph[] {
    return [
        beforeParagraph,
        getPreviewParagraph(updateProps),
        afterParagraph,
    ];
}
